import React from 'react'

import { HeadingSmall, Label } from '@pb/components'
import Sticky from 'react-stickynode'

import OPTIMIZELY from 'constants/optimizely'
import useOptimizelyToggle from 'features/account/hooks/useOptimizelyToggle'
import { HubPurchaseList } from 'features/account/purchases'
import RecentlyViewed from 'features/account/recently-viewed/index'
import { UserMenu } from 'features/account/user-menu'

import styles from '../Hub.scss'

const DesktopFailedUser: React.FC = () => {
  /**
   * Only for A/B testing purposes
   * TODO: remove when iterative testing of component is completed.
   * https://hmgroup.atlassian.net/browse/CRMMA-5370
   */
  const isRecentlyViewedEnabled = useOptimizelyToggle({
    key: OPTIMIZELY.ACCOUNT_RECENTLY_VIEWED,
  })
  return (
    <>
      <Sticky
        bottomBoundary={
          process.env.IS_REACT_FOOTER_ENABLED === 'enabled' ? '.site-footer-scroll-stop' : 'footer'
        }
      >
        <aside>
          <header className={styles.heroMessage}>
            <HeadingSmall>
              <Label copyKey="hub.custumer.los.error" />
            </HeadingSmall>
          </header>
          <UserMenu />
        </aside>
      </Sticky>
      <main id="main-content" role="main">
        <HubPurchaseList />
        {isRecentlyViewedEnabled && <RecentlyViewed />}
      </main>
    </>
  )
}

export default DesktopFailedUser
